export const es = {
    subject: `Confirma tu cuenta`,
    title: `Confirma tu cuenta`,
    message: `Por favor haz clic en el botón de abajo para confirmar tu cuenta.`,
    button: `Confirmar Cuenta`,
    link: `Si el botón anterior no funciona, copia y pega este enlace en tu navegador:`,
    thanks: `Gracias!`,
    text: `Haz clic en el siguiente enlace para confirmar tu cuenta:\n\n{{confirmUrl}}\n\nGracias!`,
    success: `Cuenta confirmada con éxito! Ahora puedes iniciar sesión.`,
};
//# sourceMappingURL=es.js.map